// Kiểm tra gh CLI đã login chưa. `gh auth status` exit 0 = OK.
// Không parse stdout vì format thay đổi giữa các bản gh.
import { spawnSync } from "node:child_process";

export type GhAuthState = "not-installed" | "not-authenticated" | "authenticated";

export function checkGhCliAuthStatus(): GhAuthState {
  // Probe binary trước. spawnSync với gh không tồn tại trả ENOENT.
  const r = spawnSync("gh", ["auth", "status"], { stdio: "ignore" });
  if (r.error && (r.error as NodeJS.ErrnoException).code === "ENOENT") {
    return "not-installed";
  }
  return r.status === 0 ? "authenticated" : "not-authenticated";
}
